/**
 * Shared sort primitives for analytics-v2 widgets.
 *
 * Extracted from CampaignsWidget + MerchantsWidget (CORE-960 R1) once the
 * pattern reached N=2. Consumers layer their own tie-break on top:
 *
 *   rows.sort((a, b) => {
 *     const c = compareNullable(getVal(a), getVal(b), dir);
 *     return c !== 0 ? c : b.orders - a.orders;  // e.g. secondary sort
 *   });
 */

export type SortDir = 'asc' | 'desc';

/**
 * Nulls-last numeric comparator. Real numbers sort by direction; nulls always
 * pin to the bottom regardless of direction so partial-data rows don't jump
 * around as the operator toggles sort direction.
 *
 * null carries "no signal" / "no meaningful denominator" semantic across
 * analytics-v2 — must sort distinctly from zero (a real value that participates
 * in ordering).
 */
export function compareNullable(a: number | null, b: number | null, dir: SortDir): number {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return dir === 'asc' ? a - b : b - a;
}
